import { Dispatch } from 'react';
import * as OkrPopUpConst from '../constants/okrPopUp.constants';
import * as ActionOkrPopUp from '../types/okrpopup.types';

export const UpdateActiveMenus = (payload: any) => (
    dispatch: Dispatch<ActionOkrPopUp.UpdateOkrPopUpTab>,
    getState: any
) => {
    dispatch({
        type: OkrPopUpConst.GET_OKR_TAB,
        payload
    });
}

export const UpdateActiveTab = (payload: any) => (
    dispatch: Dispatch<ActionOkrPopUp.UpdateOkrPopUpActiveTab>,
    getState: any
) => {
    dispatch({
        type: OkrPopUpConst.SET_OKR_TAB,
        payload
    });
}

export const UpdateModal = (payload: any) => (
    dispatch: Dispatch<ActionOkrPopUp.UpdateModal>,
    getState: any
) => {
    dispatch({
        type: OkrPopUpConst.DISABLE_MODAL,
        payload
    });
}

export const GetGoalComment = (payload: any) => (
    dispatch: Dispatch<ActionOkrPopUp.GetGoalComments>
) => {
    try {
        dispatch({
            type: OkrPopUpConst.GET_GOAL_METRIC,
            payload
        });
    } catch (e) {
        console.error(e);
    }
}

export const GetGoalMetric = (payload: any) => (
    dispatch: Dispatch<ActionOkrPopUp.GetGoalMetrics>
) => {
    try {
        dispatch({
            type: OkrPopUpConst.GET_GOAL_METRIC,
            payload
        });
    } catch (e) {
        console.error(e);
    }
}

export const UpdateSelectedMetric = (payload:any) => (
    dispatch: Dispatch<ActionOkrPopUp.SetActiveMetric>
) => {
    dispatch({
        type: OkrPopUpConst.SELECTED_METRIC,
        payload
    });
}

export const UpdateMetricGraphData = (payload:any) => (
    dispatch: Dispatch<ActionOkrPopUp.GetMetricGraphData>
) => {
    dispatch({
        type: OkrPopUpConst.METRIC_GRAPH_DATA,
        payload
    });
}

export const updateConfidence = (payload:any) => (
    dispatch: Dispatch<ActionOkrPopUp.UpdateConfide>
) => {
    dispatch({
        type: OkrPopUpConst.AFTER_METRIC_CONFIDENCE,
        payload
    });
}
